import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePrimaryButton, generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';
import {
    generateEventCardBadge,
    generateEventCardBadgeRow,
} from '#core/application/modules/tiles/event-card-badge/index.js';

const BANNER_CTA_BUTTON_LAYOUT = {
    style: {
        base: {
            minWidth: 0,
            maxWidth: 'none',
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 0,
            minHeight: '30px',
            padding: '0 8px',
        },
    },
};

function generateAvantgardeBannerCardDetails(DETAILS, SCRIM_BG) {
    return {
        container: {
            style: {
                top: '28px',
                bottom: 0,
                justifyContent: 'flex-end',
                padding: '0 0 12px',
                ...resolveBackground(SCRIM_BG),
            },
        },
        headlineText: {
            ellipsisOnLineNumber: 2,
            container: {
                flexGrow: 0,
                flexShrink: 0,
                padding: '0 12px 2px',
            },
            style: DETAILS.HEADLINE_TEXT,
        },
        innerContainer: {
            itemSpacing: '8px',
            style: {
                flexDirection: 'column',
                alignItems: 'stretch',
                justifyContent: 'flex-end',
                flexGrow: 0,
                flexShrink: 0,
                padding: '0 12px',
            },
        },
        primaryTextContainer: {
            style: {
                height: '30px',
                alignItems: 'flex-start',
                flexGrow: 0,
                flexShrink: 0,
                overflow: 'hidden',
            },
        },
        primaryText: {
            style: DETAILS.PRIMARY_MESSAGE_TEXT,
        },
        buttonsContainer: {
            itemSpacing: '6px',
            style: {
                flexDirection: 'row',
                alignItems: 'stretch',
                justifyContent: 'flex-start',
                flexGrow: 0,
                flexShrink: 0,
                padding: 0,
            },
        },
        primaryButton: merge(generatePrimaryButton(DETAILS.PRIMARY_BUTTON), BANNER_CTA_BUTTON_LAYOUT),
        secondaryButton: merge(generateSecondaryButton(DETAILS.SECONDARY_BUTTON), BANNER_CTA_BUTTON_LAYOUT),
        secondaryTextWrapper: {
            style: {
                flexGrow: 0,
                flexShrink: 0,
            },
        },
        secondaryText: {
            ellipsisOnLineNumber: 2,
            container: {
                flexGrow: 0,
                padding: '6px 12px 0',
            },
            style: DETAILS.SECONDARY_MESSAGE_TEXT,
        },
    };
}

export function avantgardeBannerCardsFactory(PALETTE) {
    return {
        BannerCard: {
            showBadgeRow: true,
            eventCard: {
                container: {
                    style: {
                        borderColor: PALETTE.PROMOTION_ACCENT_BORDER,
                    },
                },
                clickableArea: {
                    style: {
                        base: {
                            flexDirection: 'column',
                            alignItems: 'stretch',
                            justifyContent: 'flex-start',
                            flexGrow: 1,
                            alignSelf: 'stretch',
                            padding: 0,
                            width: '100%',
                            height: '100%',
                            position: 'relative',
                        },
                    },
                },
            },
            badgeRow: generateEventCardBadgeRow(PALETTE.PROMOTION_EVENT_CARD_BADGE),
            categoryBadge: generateEventCardBadge(PALETTE.PROMOTION_EVENT_CARD_BADGE),
            secondaryBadge: generateEventCardBadge(PALETTE.SECONDARY_EVENT_CARD_BADGE),
            bannerImage: {
                style: {
                    flexGrow: 1,
                    flexShrink: 1,
                    alignSelf: 'stretch',
                    minHeight: 0,
                    height: '100%',
                },
            },
            lightBannerCardDetails: generateAvantgardeBannerCardDetails(
                PALETTE.CARD_BANNER_DETAILS_LIGHT,
                PALETTE.BANNER_DETAILS_SCRIM_LIGHT_BG
            ),
            darkBannerCardDetails: generateAvantgardeBannerCardDetails(
                PALETTE.CARD_BANNER_DETAILS_DARK,
                PALETTE.BANNER_DETAILS_SCRIM_DARK_BG
            ),
        },
    };
}
